import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Gift, ChevronRight } from "lucide-react";
import { fetchVenues, fileUrl, prizeEmoji } from "@/lib/api";

const STOCK = "https://images.unsplash.com/photo-1514933651103-005eec06c04b?crop=entropy&cs=srgb&fm=jpg&q=70&w=400";

// Horizontal strip of nearby partner pubs that have a prize on offer.
export function OffersStrip({ title = "Prizes near you tonight" }) {
  const navigate = useNavigate();
  const [venues, setVenues] = useState([]);

  useEffect(() => {
    fetchVenues()
      .then((v) => setVenues(v.filter((x) => x.prize && x.prize.title)))
      .catch(() => {});
  }, []);

  if (venues.length === 0) return null;

  return (
    <div className="mb-8" data-testid="offers-strip">
      <div className="flex items-center gap-2 mb-3">
        <Gift size={16} className="text-amber-400" />
        <h2 className="font-display font-black text-lg text-slate-50">{title}</h2>
      </div>
      <div className="flex gap-4 overflow-x-auto -mx-6 px-6 pb-2" style={{ scrollbarWidth: "none" }}>
        {venues.map((v, i) => (
          <motion.button
            key={v.id}
            data-testid={`offers-strip-item-${v.id}`}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.06 }}
            whileTap={{ scale: 0.96 }}
            onClick={() => navigate(`/venue/${v.id}`)}
            className="relative shrink-0 w-56 h-36 rounded-2xl overflow-hidden text-left no-tap-highlight border border-slate-800"
          >
            <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${v.photo_url ? fileUrl(v.photo_url) : STOCK})` }} />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" />
            <div className="absolute top-2 right-2 bg-amber-400 text-slate-950 rounded-full px-2 py-0.5 text-[10px] font-black uppercase tracking-wider">
              {prizeEmoji(v.prize.kind)} Prize
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <p className="font-display font-black text-slate-50 leading-tight truncate">{v.name}</p>
              <p className="text-amber-300 text-xs font-bold truncate">{v.prize.title}</p>
              <p className="text-slate-300 text-[11px] mt-0.5 flex items-center gap-1">{v.distance} mi <ChevronRight size={11} /></p>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
